import { useSearchParams } from "react-router-dom";
import { useAzure } from "@/context/AzureContext";
import GuidedPanel from "@/components/azure/GuidedPanel";

export default function GuidedPopout() {
  const [params] = useSearchParams();
  const scenario = params.get("scenario") || null;
  const { loading } = useAzure();

  if (loading) {
    return <div className="h-screen flex items-center justify-center text-sm text-muted-foreground">Loading your lab…</div>;
  }
  return (
    <div className="h-screen w-screen bg-card">
      <GuidedPanel open popout initialScenario={scenario} onClose={() => window.close()} />
    </div>
  );
}
